import styled, {css} from 'styled-components';

import Button from '../Button';
import Select from '../Select';
import {mixins} from '../styles';

const PageNavigationWrapper = styled.div`
  display: grid;
  grid-template-columns: 160px 1fr 160px;
  align-items: center;
  ${({theme}) => css`
    margin: ${theme.spacing.s2} 0 0;
  `}
`;

const PageNavigation = styled.nav`
  ${mixins.flexAlign('center')}
`;

const PageNavigationButton = styled(Button)<{active?: boolean}>`
  position: relative;
  border-radius: 0;
  background-color: transparent;
  box-shadow: none;
  ${({theme, active}) => css`
    color: ${theme.branding.content.primary};
    z-index: ${theme.zIndex.dropdown};

    &:hover {
      color: ${theme.palette.white};
      background-color: transparent;
    }

    &::before {
      content: ' ';
      position: absolute;
      ${mixins.wh('24px')}
      z-index: ${theme.zIndex.background};
      margin: ${theme.spacing.s1};
      background-color: ${theme.palette.grey100};
      border-radius: ${theme.borderRadius.br6};
      transition: all ${theme.animation.duration}ms;
    }

    &:hover::before {
      background-color: ${theme.branding.content.primary};
    }

    &:disabled,
    &:disabled:hover {
      color: ${active ? theme.palette.white : theme.branding.content.primary};
    }

    &:disabled::before,
    &:disabled:hover::before {
      background-color: ${active ? theme.branding.content.primary : theme.palette.white};
    }
  `}
`;

const PageNavigationControl = styled(PageNavigationButton)`
  ${({theme}) => css`
    color: ${theme.branding.content.primary};
    padding: ${theme.spacing.s2};

    &::before {
      background-color: ${theme.palette.white};
      border: ${theme.dimensions.borderWidth}px solid currentColor;
    }

    &:hover {
      color: ${theme.branding.content.primary};
    }

    &:hover::before {
      background-color: ${theme.palette.white};
    }

    &:disabled,
    &:disabled:hover {
      color: ${theme.palette.grey400};
    }
  `}
`;

const TotalItems = styled.div`
  ${mixins.f2}
`;

const TotalItemsLabel = styled.span`
  color: ${({theme}) => theme.branding.content.secondary};
`;

const TotalItemsValue = styled.span`
  color: ${({theme}) => theme.branding.content.primary};
`;

const ItemsPerPage = styled.div`
  ${mixins.flexAlign('flex-end', 'center')}
  ${mixins.f2}
  gap: 10px;
  ${({theme}) => css`
    color: ${theme.branding.content.secondary};
  `}
`;

/* TODO design-system https://jira.edna.ru/browse/EP-2813 */
const ItemsPerPageSelect = styled(Select)`
  width: fit-content;
  ${({theme}) => css`
    & > div {
      background-color: ${theme.palette.grey50};
      border: none;
    }
  `}
`;

const ItemsPerPageLabel = styled.div`
  display: inline-flex;
  align-items: center;
  ${({theme}) => css`
    margin: ${theme.spacing.s1} ${theme.spacing.s2} 0 0;
    padding-top: ${theme.spacing.s05};
    color: ${theme.branding.content.secondary};
  `}
`;

export {
  PageNavigationWrapper,
  PageNavigation,
  PageNavigationButton,
  PageNavigationControl,
  TotalItems,
  TotalItemsLabel,
  TotalItemsValue,
  ItemsPerPage,
  ItemsPerPageSelect,
  ItemsPerPageLabel,
};
